import '@js-joda/locale_en-us';
import '@js-joda/timezone'; // required for js-joda locale/timezone to work
import './index.css';

import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import mixpanel from 'mixpanel-browser';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { appConfig } from '#/shared/config/AppConfig';

import App from './App';

// Init monitoring
Sentry.init({
  dsn: appConfig.sentry.dsn,
  environment: appConfig.sentry.env,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /medworld\.site/, /medworld\.com/],
});

// Init analytics
mixpanel.init(appConfig.mixpanel.token, {
  debug: true,
  track_pageview: true,
  persistence: 'localStorage',
});

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
